/* Service-worker registration (production builds only) and the party-prep questions about it:
   is the shell stored, so a reload works offline? */
export const SW_ON = typeof navigator !== "undefined" && "serviceWorker" in navigator && import.meta.env.PROD;

export function registerSw(): void {
  if (!SW_ON) return;
  window.addEventListener("load", () => { navigator.serviceWorker.register("/sw.js").catch(() => {}); });
}
/* True once a service worker controls this page and its shell cache exists. */
export async function shellReady(): Promise<boolean> {
  if (!SW_ON) return false;
  try {
    const reg = await navigator.serviceWorker.getRegistration(); if (!reg || !(reg.active || reg.waiting || reg.installing)) return false;
    const keys = await caches.keys(); return keys.some((k) => k.startsWith("ksp-shell-"));
  } catch { return false; }
}
